import { render, staticRenderFns } from "./RouterConfig.vue?vue&type=template&id=4ee5e0d8&"
import script from "./RouterConfig.vue?vue&type=script&lang=js&"
export * from "./RouterConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports